import React from "react";
import Common_Banner from "../common-components/common_banner/Common_Banner"; // ✅ Import banner

const PrivacyPolicy = () => {
    return (
        <div className="terms-wrapper">

            {/* ✅ Replaced old banner with Common_Banner */}
            <Common_Banner imgSrc="/assets/images/privacypolicy/privacy.png" title="Terms & Conditions" />

            <div className="container">
                {/* Content Section */}
                <div className="terms-content">
                    <div className="text_holder">
                        <h4>Privacy Policy </h4>
                        <p>
                            1. We understand how important personal information is & we comply with the laws related to protection and handling of personal information.
                        </p>


                        <p>
                            2. We will use customer information for the following purposes.
                        </p>
                        <ul>
                            <li>
                                <p>a) To respond to a customer inquiry</p>
                            </li>

                            <li>
                                <p>b) Sending direct mail, catalogue, and E-mail information about our products and gear manufacturing services</p>
                            </li>

                            <li>
                                <p>c) Identifying customer needs and trends in order to improve our services.</p>
                            </li>
                        </ul>


                        <p>
                            3. We manage the individual information provided by customers properly and do not disclose any information to third parties with the exception of the following cases.
                        </p>
                        <ul>
                            <li>
                                <p>a) When we have the prior consent of the customer</p>
                            </li>

                            <li>
                                <p>b) When providing to a third party such as a contracted affiliate, our related company or our overseas distributor in order to accomplish the requested task.</p>
                            </li>
                        </ul>



                        <p>In addition, for inquiries from overseas customers, there are times when our overseas distributors respond to the customers directly. </p>


                    </div>

                    <div className="text_holder">
                        <h4>Cookie Policy</h4>
                        <p>This website uses cookies.</p>
                    </div>

                    <div className="text_holder">
                        <h4>What is a cookie?</h4>
                        <p>
                            A cookie is a small text file that is sent from a website to your computer (or your other internet-enabled device) and stored there, when you access that website.
                            By using cookies, a website can obtain your browsing information (the number of visits to that website and which pages you have visited) of your computer or a device connected to the internet.
                            Note that the information obtained from cookies does not include data that can identify you.
                            You can also reject cookies in your browser settings.
                        </p>
                    </div>

                    <div className="text_holder">
                        <h4>Purpose of using a cookie on this website</h4>
                        <p>
                            By using a cookie to understand and analyze the customer access information, we can improve the convenience for users to use this website.
                            For example, you can avoid having to repeatedly enter the same information every time you visit this website through the cookie.
                            Besides, the cookie also allows us to conduct marketing research to develop products that are better suited to our customers' needs.
                        </p>
                    </div>

                </div>
            </div>

        </div >
    );
};

export default PrivacyPolicy;
